/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Banner from '@atlaskit/banner';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

import { LoadStatusPageIncidentsSuccess } from 'src/redux/global/actions/statuspage';
import { incidentBannerDismissed } from 'src/sections/global/components/flags/site-message/site-message-store';
import { getCurrentUserUuid } from 'src/selectors/user-selectors';
import { SiteMessage } from 'src/types/site-message';

import { messages } from '../sections/global/components/flags/site-message/site-message-flag.i18n';

type Props = { siteMessage?: SiteMessage };

const MessagePadding = styled.span({
  paddingRight: token('space.050'),
});

const SiteBanner = (props: Props) => {
  const currentUserUuid = useSelector(getCurrentUserUuid);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { siteMessage } = props;

  if (!siteMessage) {
    return null;
  }

  const onDismiss = (userId: string) => {
    incidentBannerDismissed(userId, siteMessage.id);
    // force banner refresh
    dispatch(LoadStatusPageIncidentsSuccess([]));
  };

  const message =
    siteMessage.linkType === 'refresh' ? (
      <MessagePadding>
        {siteMessage.text}{' '}
        <a href={window.location.href}>
          {formatMessage(messages.refreshButton)}
        </a>
      </MessagePadding>
    ) : (
      <MessagePadding>
        {siteMessage.text} &mdash;{' '}
        <a href={siteMessage.url} target="_new" rel="noopener">
          {formatMessage(messages.learnMoreButton)}
        </a>
      </MessagePadding>
    );

  let dismissButton: JSX.Element | null = null;
  if (!siteMessage.isIncident || !currentUserUuid) {
    dismissButton = null;
  } else {
    dismissButton = (
      <IconButton
        testId="dismiss-incident-banner"
        label="dismiss incident banner"
        onClick={() => onDismiss(currentUserUuid)}
        appearance="subtle"
        icon={CrossIcon}
      />
    );
  }

  return (
    <Banner
      icon={
        <StatusWarningIcon
          label="Site Message Warning Icon"
          spacing="spacious"
        />
      }
    >
      {message}
      {dismissButton}
    </Banner>
  );
};

// eslint-disable-next-line import/no-default-export
export default SiteBanner;
